import {
  HiOutlineMapPin,
  HiOutlineUsers,
  HiOutlineHomeModern,
  HiOutlineUserPlus,
  HiOutlineIdentification,
  HiOutlineMagnifyingGlass,
  HiOutlineChatBubbleLeftRight,
} from "react-icons/hi2";

export const whyBaytBuddyCards = [
  {
    id: 1,
    icon: HiOutlineUsers,
    title: "Made for Shared Living",
    description:
      "BaytBuddy is designed around how people actually search for rooms, roommates, and shared living options.",
  },
  {
    id: 2,
    icon: HiOutlineMagnifyingGlass,
    title: "Clear Listing Details",
    description:
      "Get useful room information upfront so you can make better decisions before connecting.",
  },
  {
    id: 3,
    icon: HiOutlineIdentification,
    title: "Profile-Based Access",
    description:
      "Users complete their profile before unlocking contact access, creating a more serious and structured experience.",
  },
  {
    id: 4,
    icon: HiOutlineMapPin,
    title: "Saudi-Focused Experience",
    description:
      "From city-based discovery to shared-living needs, BaytBuddy is built with Saudi Arabia in mind.",
  },
];

export const howBaytBuddyWorksSteps = [
  {
    id: 1,
    icon: HiOutlineHomeModern,
    step: "Step 1",
    title: "Browse Available Rooms",
    description:
      "Explore room listings based on your city, rent range, and living preferences.",
  },
  {
    id: 2,
    icon: HiOutlineUserPlus,
    step: "Step 2",
    title: "Create and Complete Your Profile",
    description:
      "Register, log in, and complete your profile to unlock room contact access and a more personalized experience.",
  },
  {
    id: 3,
    icon: HiOutlineChatBubbleLeftRight,
    step: "Step 3",
    title: "Connect with the Right Lister",
    description:
      "Once your profile is complete, you can connect with listers and move forward with confidence.",
  },
];